import { useEffect, useState } from "react";
import Breadcrumb from "../../../components/common/Breadcrumbs";
import { SearchInputWrapper } from "../../../components/common/datatable/filter/SearchInputWrapper";
import { DataTable } from "../../../components/common/datatable/DataTable";
import { useLazyExportRevenueEventDataQuery, useSearchRevenueEventsQuery } from "./revenueEventsApi";
import {
    SearchSelectWithList,
} from "../../../components/common/datatable/filter/SearchSelectWrapper";
import { DataTableColumn } from "../../../components/common/datatable/DataTableTypes";
import { formatValueAsDateAndTime } from "../../../helpers/utils/DateUtils";
import { SearchDatePickerWrapper } from "../../../components/common/datatable/filter/SearchDatePickerWrapper";
import { useGetAllTenantsQuery } from "../../customer/tenantApi";
import { useLazyGetAllCustomerByTenantQuery } from "../../customer/customerApi";
import {useUtilDataQuery} from "../../profile/profileApi";

const RevenueEvents = () => {

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Revenue Events", url: "/revenue-events" },
    ]);

    useEffect(() => {
        document.title = "Revenue Events";
    });

    const {data: utilData} = useUtilDataQuery("");
    const [triggerExportRevenueEventDataQuery] = useLazyExportRevenueEventDataQuery();
    const tenantData = useGetAllTenantsQuery("");
    const [customerApi, customerData] = useLazyGetAllCustomerByTenantQuery();

    const columns: DataTableColumn[] = [
        {
            label: "Order Number",
            accessor: "customerOrderNumber",
            canSort: false,
            filterOptions: [{
                filterComponent: <SearchInputWrapper
                    accessor={'customerOrderNumber.'}
                    placeholder={'Enter Order Number...'}
                    name={'orderNumber'} />
            }]
        },
        {
            label: "Tenant",
            accessor: "tenant",
            visibility: { showByDefault: false, canColumnShow: false },
            filterOptions: [{
                dependentColumns: ["Customer"],
                filterComponent: SearchSelectWithList(tenantData?.data, "name", "name", "Select Tenant...", false, "tenant"),
                overrideFilterAccessor: "tenant",
                overrideFilterLabel: "Tenant",
            }],
        },

        {
            label: "Customer",
            accessor: "customerId",
            overrideSortColumn: "customerId",
            canSort: false,
            cell: (props: any) => {
                return props.value;
            },
            filterOptions: [{
                filterComponent: SearchSelectWithList(customerData?.data, (customer: any) => `${customer.customerName} (${customer.customerNumber})`, "id", "Select Customer...", false, "customerId"),
                onDependencyUpdated: (value: any) => {
                    customerApi({ tenantName: value })
                },
                overrideFilterAccessor: "customerId",
            }],
        },
        {
            label: "Product",
            accessor: "productType",
            canSort: false,

        },
        {
            label: "Amount",
            accessor: "amount",
            canSort: false,
        },
        {
            label: "Reason",
            accessor: "reason",
            canSort: false,
        },
        {
            label: "Created Date", accessor: "creationDate", cell: (props: any) => {
                return formatValueAsDateAndTime(props.value);
            }, filterOptions: [{
                filterComponent: <SearchDatePickerWrapper accessor={"createdDateFrom"} />,
                overrideFilterAccessor: "createdDateFrom",
                overrideFilterLabel: "Created Date - From",
            }, {
                filterComponent: <SearchDatePickerWrapper accessor={"createdDateTo"} />,
                overrideFilterAccessor: "createdDateTo",
                overrideFilterLabel: "Created Date - To",
            }]
        },

    ]


    function hideFromGrid(columns:any) {
        return utilData?.customerLevel !== "SYS" ? columns.filter((el:any) => !["id"].includes(el.accessor)) : columns;
    }


    return (
        <div className="user-container px-5 py-5">
            <div className="flex justify-between">
                <Breadcrumb crumbs={crumbs} />
            </div>

            <DataTable
                columns={hideFromGrid(columns)}
                actions={{
                    fetchAction: useSearchRevenueEventsQuery,
                    exportAction: triggerExportRevenueEventDataQuery
                }}
                userSettingGroup={"Revenue-Event"}
                basePermission={"REVEVT"}
            />
        </div>
    )
}
export default RevenueEvents;